import { highlightQueryInLabel as t } from "./highlightQueryInLabel.js";
const l = (e, h, r) => ({
  ...e,
  formattedLabel: t(e.label, h, r)
});
export {
  l as highlightQueryInLabelValue
};
